import React from 'react'
import BatchesMarkPeriodsPage from './BatchesMarkPeriodsPage'
import '../styles/index.scss'

function BatchesMarkPeriodsContainer() {
    return (
        <div className='BatchesMarkPeriodsContainer'>
            <BatchesMarkPeriodsPage />
        </div>
    )
}

export default BatchesMarkPeriodsContainer